import { CodeKeyName, createCodeKeyName } from '@ukam/core/models/code-key-name';

export interface RefFieldResult {
  code?: number | null;
  name?: string | null;
}

export function createRefFieldResult(overrides: Partial<RefFieldResult> = {}): RefFieldResult {
  const defaults: RefFieldResult = {
    code: null,
    name: null,
  };

  return { ...defaults, ...overrides };
}

export interface Credential {
  userId?: string | null;
  company?: RefFieldResult | null;
  unit?: RefFieldResult | null;
  partner?: RefFieldResult | null;
  branch?: RefFieldResult | null;
  agent?: RefFieldResult | null;
  user?: RefFieldResult | null;
  userType?: CodeKeyName | null;
  accessType?: CodeKeyName | null;
  profile?: RefFieldResult | null;
  signalId?: string | null;
  email?: string | null;
  phone?: string | null;
  avatar?: string | null;
  language?: RefFieldResult | null;
}

export function createCredential(overrides: Partial<Credential> = {}): Credential {
  const defaults: Credential = {
    userId: null,
    company: createRefFieldResult(),
    unit: createRefFieldResult(),
    partner: createRefFieldResult(),
    branch: createRefFieldResult(),
    agent: createRefFieldResult(),
    user: createRefFieldResult(),
    userType: createCodeKeyName(),
    accessType: createCodeKeyName(),
    profile: createRefFieldResult(),
    signalId: null,
    email: null,
    phone: null,
    avatar: null,
    language: createRefFieldResult(),
  };

  return { ...defaults, ...overrides };
}
